import {
  projectKey,
  backstageMenuTreeFilter
} from '@/utils/gettingEnv'

const relatedIdRouters = [{
    name: '基础信息',
    key: 'accountInfos',
    toRouter: '/account/infos',
    relatedId: 'account'
  },
  {
    name: '运营信息',
    key: 'operationInfos',
    toRouter: '/operation/infos',
    relatedId: 'operationInfos'
  },
  {
    name: '发布运营信息',
    key: 'operationIssue',
    toRouter: '/operation/issue',
    relatedId: 'operationIssue'
  },
  {
    name: '需求信息',
    key: 'demandInfos',
    toRouter: '/demand/info',
    relatedId: 'demandInfos'
  },
  {
    name: '发布需求',
    key: 'demandIssue',
    toRouter: '/demand/issue',
    relatedId: 'demandIssue'
  },
  {
    name: '技术团队管理',
    key: 'techTeam',
    toRouter: '/talents/techTeam',
    relatedId: 'techTeam'
  },
  {
    name: '人才管理信息',
    key: 'talentsInfos',
    toRouter: '/talents/infos',
    relatedId: 'talentsInfos'
  },
  {
    name: '服务信息管理',
    key: 'infosManage',
    toRouter: '/server/infos',
    relatedId: 'infosManage'
  },
  {
    name: '综合信息管理',
    key: 'informationInfos',
    toRouter: '/information/infos',
    relatedId: 'information'
  },
  {
    name: '产业信息服务管理',
    key: 'informationAnnounce',
    toRouter: '/information/announcement',
    relatedId: 'industryInfos'
  },
  {
    name: '标准必要专利推送',
    key: 'StandardData',
    toRouter: '/information/standardData',
    relatedId: 'standardData'
  },
  {
    name: '公知公用技术推送',
    key: 'PublicTechnology',
    toRouter: '/information/publicTechnology',
    relatedId: 'publicTechnology'
  },
  {
    name: '创新主体管理',
    key: 'innovationSubject',
    toRouter: '/information/InnovationSubject',
    relatedId: 'innovationSubject'
  },
  {
    name: '需求审核',
    key: 'contentDemand',
    toRouter: '/content/demand',
    relatedId: 'contentDemand'
  },
  {
    name: '运营信息审核',
    key: 'contentOperation',
    toRouter: '/content/operation',
    relatedId: 'contentOperation'
  },
  {
    name: '服务信息审核',
    key: 'contentServer',
    toRouter: '/content/server',
    relatedId: 'contentServerManage'
  },
  {
    name: '我的收藏',
    key: 'favoriteMy',
    toRouter: '/favorite/my',
    relatedId: 'favoriteMy'
  },
  {
    name: '用户管理',
    key: 'systemUser',
    toRouter: '/system/user',
    relatedId: 'systemUser'
  },
  {
    name: '用户统计',
    key: 'userStatistics',
    toRouter: '/system/userStatistics',
    relatedId: 'userStatistics'
  },
  {
    name: '信息发布统计',
    key: 'messageStatistic',
    toRouter: '/system/messageStatistic',
    relatedId: 'messageStatistic'
  },
  {
    name: '培训视频',
    key: 'informationTrainingvideo',
    toRouter: '/informationTrainingvideo',
    relatedId: 'trainVideo'
  }
]

const baseOptions = [{
    title: '账户信息',
    child: [{
      name: '基础信息',
      key: 'accountInfos',
      toRouter: '/account/infos',
      relatedId: 'account'
    }]
  },
  {
    title: '运营管理',
    child: [{
        name: '运营信息',
        key: 'operationInfos',
        toRouter: '/operation/infos',
        relatedId: 'operationInfos'
      },
      {
        name: '发布运营信息',
        key: 'operationIssue',
        toRouter: '/operation/issue',
        relatedId: 'operationIssue'
      }
    ]
  },
  {
    title: '开放许可管理',
    child: [{
        name: '开放许可信息',
        key: 'licenceInfos',
        toRouter: '/licence/infos',
        relatedId:'licenceInfos'
      },
      {
        name: '发布开放许可',
        key: 'licenceIssue',
        toRouter: '/licence/issue',
        relatedId:'licenceIssue'
      }
    ]
  },
  {
    title: '需求管理',
    child: [{
        name: '需求信息',
        key: 'demandInfos',
        toRouter: '/demand/info',
        relatedId: 'demandInfos'
      },
      {
        name: '发布需求',
        key: 'demandIssue',
        toRouter: '/demand/issue',
        relatedId: 'demandIssue'
      }
    ]
  },
  {
    title: '人才管理',
    child: [{
        name: '技术团队管理',
        key: 'techTeam',
        toRouter: '/talents/techTeam',
        relatedId: 'techTeam'
      },
      {
        name: '人才管理信息',
        key: 'talentsInfos',
        toRouter: '/talents/infos',
        relatedId: 'talentsInfos'
      }
    ]
  },
  {
    title: '服务机构',
    child: [
      // { name: '金融服务管理', key: 'serverInfos', toRouter: '/server/finance' },
      {
        name: '服务信息管理',
        key: 'infosManage',
        toRouter: '/server/infos',
        relatedId: 'infosManage'
      }
    ]
  },
  // {
  //   title: '服务机构',
  //   child: [
  //     // { name: '金融服务管理', key: 'serverInfos', toRouter: '/server/finance' },
  //     { name: '服务机构管理', key: 'infosManage', toRouter: '/server/infos' },
  //   ],
  // },
  // {
  //   title: '竞争对手库管理',
  //   child: [
  //     { name: '企业监控信息', key: 'superviseInfos', toRouter: '/supervise/infos' }
  //   ]
  // },
  {
    title: '信息管理',
    child: [{
        name: '综合信息管理',
        key: 'informationInfos',
        toRouter: '/information/infos',
        relatedId: 'information'
      },
      {
        name: '产业信息服务管理',
        key: 'informationAnnounce',
        toRouter: '/information/announcement',
        relatedId: 'industryInfos'
      },
      {
        name: '标准必要专利推送',
        key: 'StandardData',
        toRouter: '/information/standardData',
        relatedId: 'standardData'
      },
      {
        name: '公知公用技术推送',
        key: 'PublicTechnology',
        toRouter: '/information/publicTechnology',
        relatedId: 'publicTechnology'
      },
      {
        name: '创新主体管理',
        key: 'innovationSubject',
        toRouter: '/information/InnovationSubject',
        relatedId: 'innovationSubject'
      }
    ]
  },
  {
    title: '内容审核',
    child: [{
        name: '需求审核',
        key: 'contentDemand',
        toRouter: '/content/demand',
        relatedId: 'contentDemand'
      },
      {
        name: '运营信息审核',
        key: 'contentOperation',
        toRouter: '/content/operation',
        relatedId: 'contentOperation'
      },
      {
        name: '开放许可信息审核',
        key: 'contentLicence',
        toRouter: '/content/licence',
        relatedId: 'contentLicence'
      },
      {
        name: '服务信息审核',
        key: 'contentServer',
        toRouter: '/content/server',
        relatedId: 'contentServer'
      }
    ]
  },

  {
    title: '收藏管理',
    child: [{
      name: '我的收藏',
      key: 'favoriteMy',
      toRouter: '/favorite/my',
      relatedId: 'favoriteMy'
    }]
  },
  {
    title: '系统管理',
    child: [{
        name: '用户管理',
        key: 'systemUser',
        toRouter: '/system/user',
        relatedId: 'systemUser'
      },
      {
        name: '用户统计',
        key: 'userStatistics',
        toRouter: '/system/userStatistics',
        relatedId: 'userStatistics'
      },
      {
        name: '信息发布统计',
        key: 'messageStatistic',
        toRouter: '/system/messageStatistic',
        relatedId: 'messageStatistic'
      }
      // { name: '日志管理', key: 'systemLog', toRouter: '/system/log' }
    ]
  }
]

function createSideOptions() {
  if (projectKey() === 'Gzkfq') return baseOptions
  const menu = backstageMenuTreeFilter(relatedIdRouters)
  console.log(menu, 'menu')
  return menu
}

const sideOptions = createSideOptions()
const nameMap = sideOptions.reduce((pre, cur) => {
  cur.child &&
    cur.child.forEach(childItem => {
      if (pre[childItem.key]) console.error('是否有重复的key' + childItem.key)
      pre[childItem.key] = cur.title
    })
  return pre
}, {})

module.exports = {
  sideOptions,
  // 映射表
  nameMap
}